<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <div class="error-icon">🔍</div>
      <h1 class="error-title">{{ $t('common.pageNotFound') }}</h1>
      <p class="error-message">{{ $t('NotFound.line7_text') }}</p>
      <button class="back-home-btn" @click="goHome">
        返回首页
      </button>
      <button class="logout-btn" @click="handleLogout">
        退出
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      // 根据用户身份跳转到对应首页
      const identity = localStorage.getItem('user_identity')
      const token = localStorage.getItem('auth_token')
      
      if (!token) {
        this.$router.replace('/login')
        return
      }
      
      switch (identity) {
        case 'ADMIN':
          this.$router.replace('/admin/dashboard')
          break
        case 'WHOLESALER':
          this.$router.replace('/wholesaler/home')
          break
        case 'STALL':
        case 'CUSTOMER':
        case 'SELLER':
          this.$router.replace('/stall/products')
          break
        case 'DRIVER':
          this.$router.replace('/delivery/grab-hall')
          break
        default:
          this.$router.replace('/login')
      }
    },
    handleLogout() {
      // 调用 Vuex store 的 logout 方法统一处理
      this.$store.dispatch('auth/logout')
      // 清除临时凭证
      sessionStorage.clear()
      // 跳转到登录页
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.not-found-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.not-found-content {
  text-align: center;
  color: white;
  max-width: 500px;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  line-height: 1;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  margin-bottom: 10px;
}

.error-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.error-title {
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 15px 0;
}

.error-message {
  font-size: 16px;
  opacity: 0.9;
  margin: 0 0 30px 0;
}

.back-home-btn {
  background: white;
  color: #667eea;
  border: none;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.back-home-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.back-home-btn:active {
  transform: translateY(0);
}

.logout-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 12px;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.logout-btn:active {
  transform: scale(0.98);
}
</style>
